export default __webpack_public_path__ + "static/media/topo-lines.3b0227fb.png";